import { ButtonBase, Grid } from '@mui/material';
import React, { Fragment, memo } from 'react';
import ShaxmatkaHomeTooltip from '../tooltips/ShaxmatkaHomeTooltip';

const Shaxmatka2Row = ({
  homesData,
  blockIndex,
  padezdIndex,
  floorNumber,
  size,
  isEditing,
  toggleSelectionItem = () => {},
  settingsMenuValue = '',
}) => {
  // const onClick = (item) => {
  //   if (floorNumber == 16) {
  //     homesData?.forEach((data) => {
  //       if (
  //         data?.number % 5 == item?.number % 5 &&
  //         data?.stage != 1 &&
  //         data?.number / 5 > 1
  //       )
  //         toggleSelectionItem(data.id, padezdIndex, blockIndex);
  //     });
  //   } else {
  //     toggleSelectionItem(item.id, padezdIndex, blockIndex);
  //   }
  // };
  return (
    <Fragment>
      <Grid
        container
        rowSpacing={0}
        columns={{
          xs: parseInt(size),
          sm: parseInt(size),
        }}
        className={'sheet-home-row'}
      >
        {padezdIndex == 0 && (
          <Grid
            item={true}
            sm={1}
            xs={1}
            className='sheet-home-cell !-ml-2.5 !mr-0'
          >
            <ButtonBase
              className='sheet-home-row-floor h-full w-8 text-sm font-medium !cursor-default'
              disableRipple
            >
              {floorNumber}
            </ButtonBase>
          </Grid>
        )}
        {homesData.filter((home) => home.stage == floorNumber).length > 0
          ? homesData
              .filter((home) => home.stage == floorNumber)
              .map((item) => (
                <Grid
                  item={true}
                  sm={1}
                  xs={1}
                  key={`block-${blockIndex}-${padezdIndex}-home-${item.id}`}
                  id={`block-${blockIndex}-${padezdIndex}-home-${item.id}`}
                  className={`sheet-home-cell floor-${floorNumber} `}
                >
                  <ShaxmatkaHomeTooltip
                    home={item}
                    disableFocusListener={isEditing}
                    disableHoverListener={isEditing}
                  >
                    <ButtonBase
                      className={`block-${blockIndex}-${padezdIndex}-home home-item status-${
                        item?.contract?.status == 2 ? 'completed' : item?.status
                      }${item.disabled ? ' is-disabled' : ''}`}
                      id={`home-${item.id}`}
                      onClick={
                        // () => onClick(item)
                        () =>
                          toggleSelectionItem(item.id, padezdIndex, blockIndex)
                      }
                    >
                      {settingsMenuValue == 'rooms' ? (
                        !(item.stage && parseInt(item.stage) < 0) ? (
                          item.rooms ? (
                            <div>{item.rooms}x</div>
                          ) : (
                            ''
                          )
                        ) : (
                          <div>P</div>
                        )
                      ) : (
                        <div>{item.number}</div>
                      )}
                    </ButtonBase>
                  </ShaxmatkaHomeTooltip>
                </Grid>
              ))
          : [1].map((item) => (
              <Grid
                item={true}
                sm={1}
                xs={1}
                key={`block-${blockIndex}-home-empty-${item}`}
                id={`block-${blockIndex}-home-empty-${item}`}
                className={`sheet-home-cell sheet-home-empty-cell floor-${floorNumber}`}
              >
                <ButtonBase className='home-item is-empty'>
                  <div className='home-item-data'></div>
                </ButtonBase>
              </Grid>
            ))}
      </Grid>
    </Fragment>
  );
};

export default memo(Shaxmatka2Row);
